import dataStore from '../../../data/data';
import Mediaprocessing from '../../mediaprocessing/mediaprocessing';

const Loader = async () => {
  const data = dataStore.getState();
  const sessionId = data.mirror.sessionId;

  if (!sessionId) return;

  const res = await fetch(
    `${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-session-get?sessionId=${sessionId}`
  );

  const session = await res.json();

  if (!session?.participants?.length) {
    console.log('No participants returned', session);
    return;
  }

  const participants = session.participants || [];
  const vitruvian = data.mirror.vitruvianId;
  const vitruvianParticipant = participants.find(p => p.vitruvianId === vitruvian);
  const peers = participants.filter(p => p.vitruvianId !== vitruvian);

  await new Mediaprocessing().run({
      id: vitruvian,
      role: 'vitruvian',
      timestamp: vitruvianParticipant.timestamp
  });

  for (const peer of peers) {
    await new Mediaprocessing().run({
        id: peer.vitruvianId,
        role: 'peer',
        timestamp: peer.timestamp
    });
  }
};

export default Loader;